import React from 'react';
import axios from "axios";
import { Link } from "react-router-dom";
import { BUBBLE_LOADING, META_FACEBOOK, BREADCRUMB_SCHEMA, ARTICLE_POPUP_CONSTANT } from '../../constants/FrontEndConstant';
import { LANGUAGE_CODE, API_URL, META_TITLE_HOME_PREPEND } from '../../constants/DotEnv';
import VorlagenHeader from '../subPageHeader/SubPageHeader';

class Vorlagen extends React.Component {
    constructor() {
        super();
        this.state = {
            data: [],
            loading: 'false',
            title: '',
            sub_title: '',
            main_slug: '',
            text_area_1: '',
            text_area_2: '',
            selected_category: '',
            article_categories: [],
            article_items: [],
            filtered_article_items: [],
        }
    }
    componentWillUnmount() {
        setTimeout(() => {
            window.setOgTag(META_FACEBOOK['og_title'], META_FACEBOOK['og_description'], META_FACEBOOK['og_image'], META_FACEBOOK['og_url'])
            window.removeSchema();
        }, 100)
    }
    async componentDidMount() {
        this.scrollUpFunction();
        await this.vorlagenContent();
        setTimeout(() => {
            var schema2 = window.positionCreate(BREADCRUMB_SCHEMA['vorlagen']['schema2']['position'], BREADCRUMB_SCHEMA['vorlagen']['schema2']['url'], BREADCRUMB_SCHEMA['vorlagen']['schema2']['name']);
            var schemaObject = window.schemaObj(BREADCRUMB_SCHEMA['schema1'], schema2, BREADCRUMB_SCHEMA['vorlagen']['schema3']);
            window.setSchema(schemaObject);
        }, 100)
    }
    scrollUpFunction = () => {
        /**for scrolling up page */
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    async vorlagenContent() {
        this.setState({ loading: 'true' })
        var headers = {
            "Content-Type": "application/json"
        }
        let data = '';
        let title = '';
        let sub_title = '';
        let main_slug = '';
        let self = this;
        let text_area_1 = '';
        let text_area_2 = '';
        let count = 0;
        let article_items = [];
        let filtered_article_items = [];
        let article_browser_data = {};
        let article_categories = [];
        let meta_title = '';
        let meta_description = '';
        let meta_keywords = '';
        let blue_text = '';
        let required_btn = '';
        let required_btn_text = '';
        let required_btn_link = '';
        let og_image = META_FACEBOOK['og_image'];
        axios.get(API_URL + "/cms/getCmsByID/96/" + LANGUAGE_CODE, { headers: headers })
            .then((response) => {
                data = response.data.success.cms.articlecms;
                title = data[LANGUAGE_CODE]['title'];
                sub_title = data[LANGUAGE_CODE]['sub_title'];
                main_slug = response.data.success.cms.slug;
                text_area_1 = data[LANGUAGE_CODE]['text_area1'];
                text_area_2 = data[LANGUAGE_CODE]['text_area2'];
                blue_text = data[LANGUAGE_CODE]['blue_text'];
                required_btn = data.required_btn;
                required_btn_text = data[LANGUAGE_CODE]['required_btn_text'];
                required_btn_link = data.required_btn_link;
                meta_title = META_TITLE_HOME_PREPEND + data[LANGUAGE_CODE]['title'];
                meta_description = data[LANGUAGE_CODE]['meta_description'];
                meta_keywords = data[LANGUAGE_CODE]['meta_keyword'];
                window.setOgTag(meta_title, meta_description, og_image, window.location.href);
                window.setMeta({ "description": meta_description, "keywords": meta_keywords });
                window.setDocumentTitle(meta_title);
                article_browser_data = response.data.success.cms.article_browser;
                article_categories = Object.keys(article_browser_data).map(key => key);
                Object.keys(article_browser_data).forEach(function (category) {
                    article_browser_data[category].forEach(function (key) {
                        article_items[count] = [];
                        article_items[count]['category'] = category;
                        article_items[count]['article_short_name'] = key['article_short_name'];
                        article_items[count]['slug'] = key['slug'];
                        count++;
                    });
                });
                filtered_article_items = article_items;
                self.setState({ data, loading: 'false', title, sub_title, main_slug, text_area_1, text_area_2, article_categories, article_items, filtered_article_items, blue_text, required_btn, required_btn_text, required_btn_link })
            })
            .catch((error) => {
                self.setState({ loading: 'false' })
            })
    }
    filterItems = (e, category) => {
        let filterElements = document.querySelectorAll('.theme-after');
        filterElements.forEach(function (elem) {
            elem.classList.remove('active');
        });
        e.target.className = 'active theme-after';
        e.preventDefault();
        if (category === "All") {
            this.setState({
                selected_category: category,
                filtered_article_items: this.state.article_items,
            });
        } else {
            this.setState({
                selected_category: category,
                filtered_article_items: this.state.article_items.filter(
                    (item) => item.category === category
                ),
            });
        }
    };
    render() {
        return (
            <main>
                {(this.state.loading === 'true') ?
                    BUBBLE_LOADING
                    : null
                }
                {/* <!-- banner text ---> */}
                <VorlagenHeader data={this.state.data} title={this.state.title} sub_title={this.state.sub_title} />
                {/* <!-- banner-text-end --> */}
                <section className="empirical-research bg-gray">
                    <div className="container">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-12">
                                <h2 dangerouslySetInnerHTML={{ __html: this.state.text_area_1 }}></h2>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- Article :: Start --> */}
                <section class="container mt-5 mb-5">
                    <div class="portfolio-filter m-20px-b">
                        <ul class="filter filter-01 text-center">
                            <li class="active theme-after" onClick={(e) => this.filterItems(e, 'All')}>{ARTICLE_POPUP_CONSTANT[LANGUAGE_CODE]['all']}</li>
                            {this.state.article_categories.map((category) => (
                                <li class="theme-after" onClick={(e) => this.filterItems(e, category)}>{category}</li>
                            ))}
                        </ul>
                    </div>
                    {/* <!-- Article Filter --> */}
                    <div class="portfolio-content lightbox-gallery">
                        <ul class="portfolio-cols portfolio-cols-5 d-flex flex-wrap">
                            {
                                this.state.filtered_article_items.map((item, itemIndex) => {
                                    return (
                                        <li class="portfolio-item illustration website" key={itemIndex}>
                                            <div class="portfolio-col">
                                                <a href={"/vorlagen/" + item.slug}>
                                                    <div class="portfolio-info d-flex justify-content-center align-items-center">
                                                        <div class="portfolio-info-inner">
                                                            <h6>{item.article_short_name}</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    {/* <!-- Article Content --> */}
                </section>
                {/* <!-- Article :: End --> */}
                <section className="empirical-research bg-gray">
                    <div className="container">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-12">
                                <h2 dangerouslySetInnerHTML={{ __html: this.state.text_area_2 }}></h2>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="start-now analysiere theme-main">
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-12">
                                <div className="understand-research text-center">
                                    <h2 className="text-white mb-0 font-weight-bold">{this.state.blue_text}</h2>
                                    {this.state.required_btn == '1' ?
                                        <div className="start-chapter text-center">
                                            <Link to={this.state.required_btn_link} className="btn btn-clr text-uppercase text-white font-18" title={this.state.required_btn_text}>{this.state.required_btn_text}</Link>
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}
export default Vorlagen;
